import { render, staticRenderFns } from "./KoreanLsportSpecialCart.vue?vue&type=template&id=64d6436e&scoped=true"
import script from "./KoreanLsportSpecialCart.vue?vue&type=script&lang=js"
export * from "./KoreanLsportSpecialCart.vue?vue&type=script&lang=js"
import style0 from "./KoreanLsportSpecialCart.vue?vue&type=style&index=0&id=64d6436e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d6436e",
  null
  
)

export default component.exports